import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function RemplacementSangle() {
  const checks = [
    "Diagnostic du type de sangle (14 mm ou 22 mm)",
    "Retrait de la sangle usée du dévidoir",
    "Nettoyage et inspection de l'enrouleur",
    "Pose de la nouvelle sangle avec tension adaptée",
    "Vérification du rembobinage et du guidage",
    "Test de montée, descente et position intermédiaire",
  ];

  return (
    <section className="bg-[#F4F8FB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Remplacement de sangle (14 et 22 mm)
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Le choix de la sangle dépend directement du poids et de la largeur du tablier de votre volet roulant. La sangle de 14 mm convient aux volets standards de petite et moyenne taille. La sangle de 22 mm est réservée aux grands volets ou aux tabliers lourds en aluminium ou en PVC renforcé. Une sangle trop fine pour un volet lourd cèderait rapidement, tandis qu&apos;une sangle trop large serait inutile et moins maniable.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Notre technicien mesure la largeur de l&apos;emplacement sangle, vérifie le type d&apos;enrouleur et sélectionne la sangle adaptée. Nous proposons des sangles en polyester haute résistance, traitées anti-UV, qui offrent une durée de vie supérieure aux sangles bas de gamme. Le remplacement dure généralement moins d&apos;une heure et ne nécessite aucun travaux lourds.
            </p>

            <ul className="space-y-3 mb-8">
              {checks.map((check) => (
                <li key={check} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                    <i className="ri-check-line text-[#00B3A4] text-sm"></i>
                  </span>
                  <span className="text-[#2F4A63] text-base">{check}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Professional%20technician%20replacing%20a%20beige%20woven%20roller%20shutter%20strap%20with%20a%20new%20one%20using%20precision%20tools%20in%20a%20residential%20interior%20near%20Strasbourg%20clean%20white%20walls%20natural%20daylight%20professional%20service%20photography%20warm%20tones&width=700&height=520&seq=sang-rempl&orientation=landscape" alt="Remplacement d'une sangle de volet roulant à Strasbourg" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}